<template>
  <el-dialog :title="form.id ? '修改规则' : '创建规则'" :visible.sync="cVisible" width="600px">
    <el-form :model="form" label-position="top" label-width="100" size="small">
      <el-form-item label="规则名称">
        <el-input size="small" v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="规则说明" label-width="100">
        <el-input size="small" v-model="form.comment" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="分值。参与计分的规则，负数代表扣分，正数代表加分。不参与计分的规则分值设置为正数。" label-width="100">
        <el-input size="small" v-model="form.score" autocomplete="off" type="number"></el-input>
      </el-form-item>

      <el-form-item label="是否计分。选 '是' 则该规则参与实际扣分，选 '否' 用于设置分值限制子规则的扣分次数。" label-width="100">
        <el-switch active-text="是" inactive-text="否" v-model="form.scoreable" active-color="#13ce66"
          inactive-color="#ff4949">
        </el-switch>
      </el-form-item>

      <el-form-item label="是否多次。选 '是' 则该规则可多次扣分，直至其上级的分值被扣光" label-width="100">
        <el-switch active-text="是" inactive-text="否" v-model="form.multiple" active-color="#13ce66"
          inactive-color="#ff4949">
        </el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cVisible = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>

import {
  createEvaluationRule,
  updateEvaluationRule
} from "@/api/evaluation-rule";
import defaultForm from "./default-form.json";

export default {
 data() {
  return {
    form: defaultForm
  }
 },
 computed: {
  cVisible: {
    get(){
      return this.visible;
    },
    set(val){
      this.$emit('update:visible', val);
    }
  }
 },
 methods: {
  submit(){
      if(this.form.id){
        updateEvaluationRule(this.form.id, this.form).then(() => {
          this.$emit('submited');
          this.cVisible = false;
        });
      } else {
    
        createEvaluationRule(this.form).then(() => {
          this.$emit('submited');
          this.cVisible = false;
        });
      }
    }
 },
 components: {},
 props: {
  data: {
    type: Object,
    default: () => {
      return defaultForm;
    }
  },
  visible: {
    type: Boolean,
    default: false
  },
 },
 watch: {
  data: {
    handler(val) {
      this.form = JSON.parse(JSON.stringify(val));
    },
    deep: true
  }
 },
}
</script>
<style></style>